import React, { useEffect, useState, useCallback } from "react";
import { Container } from "reactstrap";
import MapContainer from "../../components/MapContainer";
import Footer from "../../pages/Footer/Footer";
import Header from "../../components/Header";
import { PRODUCT_META } from "./config";
import ExplorerSidebar from "./ExplorerSidebar";
import { hp_species_layers, withRasterClipParams } from "./layers";
import { all_block_layer } from "../../utils/Blocks_layer";
import axios from "axios";
import L from "leaflet";

function HpExplorerPage() {
  // Placeholder states for layers; wire to real data when ready
  const [administrativeLayers, setAdministrativeLayers] = useState([]);
  const [selectedSpecies, setSelectedSpecies] = useState([]); // Store selected species IDs/names
  const [predictedLayers, setPredictedLayers] = useState([]);
  const [heatmaps] = useState([]);
  const [mapType] = useState("satellite");
  const [isExploring, setIsExploring] = useState(false);
  const [marker, setMarker] = useState(null);
  const bufferRadiusMeters = 4000;
  const [hpBounds, setHpBounds] = useState(null);

  // Function to update layers with current buffer
  const updateLayersWithBuffer = useCallback(() => {
    if (!marker) {
      const layersWithoutBuffer = hp_species_layers.filter(layer =>
        selectedSpecies.includes(layer.sci_name)
      );
      setPredictedLayers(layersWithoutBuffer);
      return;
    }
  
    const selectedLayers = hp_species_layers.filter(layer =>
      selectedSpecies.includes(layer.sci_name)
    );
  
    const clippedLayers = withRasterClipParams(
      selectedLayers,
      marker,
      bufferRadiusMeters
    );
  
    setPredictedLayers(clippedLayers);
  }, [marker, selectedSpecies, bufferRadiusMeters]);
  

  // Update layers when marker or selected species changes
  useEffect(() => {
    updateLayersWithBuffer();
  }, [updateLayersWithBuffer]);

  // Handle layer toggle
  const handleToggleLayer = useCallback((layer) => {
    const sciName = layer.sci_name;
    setSelectedSpecies(prev => {
      const exists = prev.includes(sciName);
      if (exists) {
        return prev.filter(name => name !== sciName);
      } else {
        return [...prev, sciName];
      }
    });
  }, []);

  return (
    <div className="main_app_div">
      <Header title={PRODUCT_META.title} />

      <main className="home-content">
        <Container fluid>
          <div className="explorer-layout"> 
<ExplorerSidebar
  description={PRODUCT_META.description}
  species={hp_species_layers}
  isExploring={isExploring}
  marker={marker}
  bufferKm={bufferRadiusMeters / 1000}
  activeLayers={predictedLayers}
  selectedSpecies={selectedSpecies} // Add this line
  onStartExploring={() => setIsExploring(true)}
  onCancelExploring={() => {
    setIsExploring(false);
    setMarker(null);
    setSelectedSpecies([]);
  }}
  onToggleLayer={handleToggleLayer}
/>
            <div className="explorer-map">
              <MapContainer
                layers={administrativeLayers}
                predictedLayers={predictedLayers}
                heatmaps={heatmaps}
                mapType={mapType}
                style={{ height: "100%" }}
                bounds={hpBounds}
                onMapClick={(latlng) => {
                  // Always set marker on click so the radius renders
                  setMarker(latlng);
                  setIsExploring(true);
                }}
                marker={marker}
                bufferRadiusMeters={marker ? bufferRadiusMeters : undefined}
                enableBufferCircle={true}
              />
            </div>
          </div>
        </Container>
      </main>

      <Footer />
    </div>
  );
}

export default HpExplorerPage;